import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventSubscribeService {
  private eventSubject: Subject<any> = new ReplaySubject(1);

  constructor() {}

  // set observable of this subject
  get $getEventSubject(): Observable<any> {
    return this.eventSubject.asObservable();
  }
  // remove from observer
  resetEventObserver(): void {
    this.eventSubject = new ReplaySubject(1);
  }
  // send event to observers
  sendCustomEvent(): void {
    this.eventSubject.next(true);
  }
}
